import { AppViewMode } from 'src/constants/uiConsts';
import { RouteAction } from 'src/routes/types';

import { OnboardingSetupPage } from './page';

const action: RouteAction = (context) => {
  const isInternalUser = context.portalConfig.viewMode === AppViewMode.INTERNAL;
  const appTitle =
    isInternalUser || context.isAssemblyDomain ? 'Assembly' : 'Copilot';

  return {
    chunks: ['onboarding-setup'],
    ...(isInternalUser
      ? {
          description: `Sign up for a ${appTitle} account.`,
          title: `${appTitle} • Sign up`,
        }
      : {}),
    component: <OnboardingSetupPage />,
  };
};

export default action;
